export default __webpack_public_path__ + "static/media/infografia_post_esterilizacion.2e6ffdc1.pdf";